<script setup lang="ts">
import EpisodView from "./components/Sport/Episod/EpisodView.vue";

</script>

<template>
    <router-view />
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
